const UploadFileStyles = () => {
    return {
        container: {
            maxWidth: '1200px',
            border: '1px solid #E0E0E0',
            borderRadius: '10px',
            marginBottom: '30px',
          },
          container_title_box: {
            padding: '16px',
            borderBottom: '1px solid #E0E0E0',
            display: 'flex',
            alignItems: 'center',
          },
          container_title_icon: {
            fontSize: '28px',
            color: '#4ABBA7',
            marginRight: '8px',
          },
          container_title_text: {
            fontSize: '20px',
            fontWeight: 600,
            color: '#2B2B2B',
          },
          content: {
            display: 'flex',
            height: '470px',

          },
          sidebar: {
            width: '280px',
            borderRight: '1px solid #E0E0E0',
            padding: '16px',
          },
          sidebar_title: {
            fontWeight: 500,
            fontSize: '20px',
            padding: '10px 4px',
          },
          sidebar_tabs_container: {
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
          },
          sidebar_tab: {
            borderRadius: '10px',
            border: '1px solid #E0E0E0',
            backgroundColor: '#FFFFFF',
            transition: 'all 0.2s ease',
            cursor: 'pointer',
            padding: '10px',
            '&:hover': {
              borderColor: '#4ABBA7',
              backgroundColor: 'rgba(219, 255, 245, 0.3)',
            },
          },
          sidebar_tab_active: {
            borderColor: '#4ABBA7',
            backgroundColor: 'rgba(219, 255, 245, 0.3)',
          },
          sidebar_tab_content: {
            display: 'flex',
            alignItems: 'center',
            color: '#4C585B',
          },
          sidebar_tab_content_active: {
            color: '#4ABBA7',
          },
          indicator_icon: {fontSize: '26px', marginRight: '4px', marginTop: '2px'},
          sidebar_tab_content_text: {
            marginLeft: '6px',
            fontSize: '16px',
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: '1px',
          },
          upload_area: {
            flex: 1,
            padding: '24px',
          },
          upload_area_empty: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            color: '#6B7280',
            textAlign: 'center',
            padding: '32px',
          },
          upload_area_empty_icon: {
            fontSize: '60px',
            color: '#CBD5E1',
            marginBottom: '24px',
          },
          upload_area_empty_primary_text: {
            fontWeight: 500,
            fontSize: '24px',
            color: '#4B5563',
            marginBottom: '16px',
          },
          upload_area_empty_secondary_text: {
            fontSize: '16px',
            color: '#6B7280',
            maxWidth: '400px',
          },
          upload_file_animation: {
            initial: {
                opacity: 0
            },
            animate: {
                opacity: 1
            },
            transition: {
                duration: 1
            }
          },
          upload_file_title: {fontWeight: '500', fontSize: '20px', marginBottom: '10px'},
          drop_zone: {
            border: '1px dashed rgb(168, 168, 168)',
            borderWidth: '2px',
            borderRadius: '10px',
            height: '280px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            transition: '0.5s',
            position: 'relative',
            cursor: 'pointer',
            '&:hover': {
              backgroundColor: 'rgba(219, 255, 245, 0.3)',
              borderColor: '#4ABBA7',
            },
          },
          drop_zone_active: {
            borderColor: '#4ABBA7',
            boxShadow: '0 0 10px #4ABBA7',
          },
          drag_here_text: {
            margin: '10px 0',
            fontSize: '20px',
            fontWeight: 450,
            borderBottom: '2px solid #4ABBA7',
            paddingBottom: '10px',
            marginBottom: '20px',
            width: 'fit-content',
          },
          drag_text: {fontSize: '20px'},
          selected_file_name: {
            top: '35px',
            left: '50%',
            transform: 'translateX(-50%)',
            color: '#4ABBA7',
            fontSize: '20px',
            fontWeight: 500,
            position: 'absolute',
          },
          uploading_file_message: {
            top: '15px',
            left: '50%',
            transform: 'translateX(-50%)',
            fontSize: '18px',
            fontWeight: 500,
            position: 'absolute',
          },
          cloud_icon:{
            fontSize: '60px',
            transition: '0.5s',
            color: 'rgb(168, 168, 168)',
          },
          cloud_icon_active: {
            color: '#4ABBA7',
          },
          cloud_icon_rejected: {
            color: 'red',
          },
          submit_box: {display: 'flex', justifyContent: 'space-around', alignItems: 'center', marginTop: '30px'},
          facility_box: {width: '40%'},
          input_label: {color: '#4ABBA7'},
          facility_info_select: {width: '100%', marginBottom: '20px'},
          submit_button: {width: '50%', height: '55px'},
          sample_data: { 
            width: '320px', 
            borderLeft: '1px solid #E0E0E0',
            p: 3,
            backgroundColor: '#F8F9FA',
            overflow: 'hidden'
          },
          sample_data_animation: {
            initial: {
              x: 150,
              opacity: 0
            },
            animate: {
              x: 0,
              opacity: 1
            },
            transition: {
                duration:  0.6
            }
          },
          sample_data_title_box: {
            display: 'flex',
            alignItems: 'center',
            marginBottom: '10px',
          },
          sample_data_title_tooltip: {
            fontSize: '14px',
            p: 1,
          },
          sample_data_tooltip_icon: {
            fontSize: '24px',
            color: '#4ABBA7',
            mr: 1,
            cursor: 'pointer',
          },
          sample_data_title_text: {
            fontSize: '18px',
            fontWeight: '600',
            color: '#2B2B2B',
          },
          sample_data_table_box: {
            marginBottom: '10px',
            boxShadow: '0px 0px 2px black',
            borderRadius: '10px',
            height: '330px',
            overflow: 'hidden',
          },
          sample_data_table_heading: {
            height: '30px',
            borderRadius: '10px 10px 0 0',
            display: 'flex',
            alignItems: 'center',
            paddingLeft: '8px',
            borderBottom: '1px solid #B9B8B8',
          },
          table_dotes: {
            backgroundColor: '#FF5E56',
            width: '12px',
            height: '12px',
            borderRadius: '100%',
            margin: '0 4px',
          },
          red_dot: {
            backgroundColor: '#FF5E56',
          },
          orange_dot: {
            backgroundColor: '#FFBC2C',
          },
          green_dot: {
            backgroundColor: '#26C83E',
          },
          sample_data_table_content: {
            display: 'flex',
            flexDirection: 'column',
          },
          sample_data_table_field: {
            display: 'flex',
          },
          sample_data_table_value: {
            height: '30px',
            width: '34%',
            border: '1px solid #B9B8B8',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '4px',
          },
          sample_data_table_value_text: {
            textAlign: 'left',
            fontWeight: '500',
            color: '#3C3D37',
          },
          sample_data_table_footer_animation: {
            initial: {
              x: 150,
              opacity: 0,
            },
            animate: {
              x: 0,
              opacity: 1,
            },
            transition: {
              duration: 1,
            },
          },
          sample_data_table_footer: {display: 'flex', justifyContent: 'center', marginTop: '20px'},
          download_sample_data_button: {
            width: '50%',
            marginLeft: '10px',
            backgroundColor: '#4ABBA7',
            borderRadius: '8px',
            padding: '6px 20px',
            fontWeight: '500',
            textTransform: 'none',
            fontSize: '16px'
          },
          sample_data_empty_box: { 
            display: 'flex', 
            flexDirection: 'column',
            alignItems: 'center', 
            justifyContent: 'center', 
            height: '100%',
            color: '#6B7280',
            textAlign: 'center',
            p: 4
          },
          sample_data_empty_icon: { fontSize: '60px', color: '#CBD5E1', mb: 3 },
          sample_data_epty_primary_text: { 
            fontWeight: '500', 
            fontSize: '24px', 
            color: '#4B5563',
            mb: 2
          },
          sample_data_epty_secondary_text: { 
            fontSize: '16px', 
            color: '#6B7280',
            maxWidth: '400px'
          }
    }
}

export default UploadFileStyles